
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  BaseText,
  Modal,
  ModalButton,
  HelperView,
  ButtonPrimary,
  LoaderIndicator
} from '@warrenbrasil/nebraska-web';
import { WithdrawsAPI } from '@/modules/transaction/services/withdraws';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  trackConfirmCancelWithdrawClick,
  trackRefuseCancelWithdrawClick
} from '../../track-events';

@Component({
  components: {
    Modal,
    ModalButton,
    BaseText,
    HelperView,
    ButtonPrimary,
    LoaderIndicator
  }
})
export default class CancelWithdrawModal extends Vue {
  private withdrawsApi = new WithdrawsAPI();

  @Prop({ type: String, required: true })
  private id!: string;

  @Prop({ type: Boolean, required: true })
  private isOpen!: boolean;

  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: String, required: true })
  private content!: string;

  readonly NebraskaColors = NebraskaColors;

  hasError = false;
  isLoading = false;

  private async onClickCancelWithdrawal() {
    this.isLoading = true;
    this.hasError = false;
    trackConfirmCancelWithdrawClick();
    try {
      await this.withdrawsApi.cancelWithdrawal(this.id);
      this.cancelTransaction();
      this.closeModal();
    } catch (e) {
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  @Emit('cancel-transaction')
  cancelTransaction() {}

  @Emit('close-modal')
  closeModal() {
    this.hasError = false;
  }

  onClickRefuseCancelWithdrawal() {
    trackRefuseCancelWithdrawClick();
    this.closeModal();
  }
}
